var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['decoration', _vm.className]},[_c('inline-svg',{attrs:{"src":require(("@/assets/icons/" + _vm.type + ".svg")),"title":"Decoration","width":_vm.width}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }